"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterPerSquareSecond = void 0;
var uom_1 = require("uom");
var UnitDivide = require("../unit-divide");
var velocity_1 = require("./velocity");
/** The metric unit for acceleration quantities ( <code>m/s²</code> ). */
exports.MeterPerSquareSecond = UnitDivide.velocityBySecond("MeterPerSquareSecond", velocity_1.MeterPerSecond, uom_1.BaseUnits.Second);
//# sourceMappingURL=acceleration.js.map